<template>
    <div id="sidebar-catalogue" class="sidebar p-5 min-h-screen border-r border-gray hidden lg:flex flex-col lg:fixed bg-white lg:h-full">
        <jet-application-mark class="block h-24 w-auto mx-auto mb-5" />

        <!-- Select customer dropdown -->
        <customer-selector ref="selector" v-if="isCustomer" />

        <nav class="h-full mt-5">
            <ul>
                <li>
                    <jet-nav-link :href="route('dashboard')" :active="route().current('dashboard')">
                        <img src="/images/icons/chevrons-left.svg" alt="Left Chevron" width="18" height="18" />
                        <span class="text-sm">Back to Dashboard</span>
                    </jet-nav-link>
                </li>
                <li class="h-2"></li>
                <li>
                    <jet-nav-link :href="route('catalogue')" :active="route().current('catalogue', '') || route().current('catalogue', { category: '' })">All Products</jet-nav-link>
                </li>
                <li>
                    <jet-nav-link :href="route('catalogue.hot_buys')" :active="route().current('catalogue.hot_buys')">Hot Buys</jet-nav-link>
                </li>
                <li v-if="isCustomer">
                    <jet-nav-link :href="route('catalogue.favourites')" :active="route().current('catalogue.favourites')">Favourites</jet-nav-link>
                </li>
            </ul>

            <h3 class="mt-3 text-lg border-b border-gray font-bold pb-1">Shop By Category</h3>

            <ul class="overflow-y-auto categories" :class="{'categories-with-customers' : multipleCustomers}">
                <li v-for="category in categories" :key="category.id" :class="{ 'ml-5': category.parent_id }">
                    <jet-nav-link :href="route('catalogue', category.slug)" :active="route().current('catalogue', category.slug)">
                        {{ category.title }}
                    </jet-nav-link>
                </li>
            </ul>
        </nav>

        <!-- Hidden to save whitespace, don't think this needs to be on the catalogue sidebar anyway. -->
        <div class="hidden sm:flex sm:items-center" style="display: none !important;">
            <!-- Settings Dropdown -->
            <div class="relative">
                <jet-dropdown align="bottom" width="48">
                    <template #trigger>
                        <span class="inline-flex rounded-md">
                            <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md text-gray-500 bg-white hover:text-gray-700 focus:outline-none transition">
                                {{ $page.props.user.name }}

                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </span>
                    </template>

                    <template #content>
                        <!-- Account Management -->
                        <div class="block px-4 py-2 text-xs text-gray-400">
                            Manage Account
                        </div>

                        <jet-dropdown-link :href="route('profile.show')">
                            Profile
                        </jet-dropdown-link>

                        <div class="border-t border-gray-100"></div>

                        <!-- Authentication -->
                        <form @submit.prevent="logout">
                            <jet-dropdown-link as="button">
                                Log Out
                            </jet-dropdown-link>
                        </form>
                    </template>
                </jet-dropdown>
            </div>
        </div>
    </div>
</template>

<script>
import { usePage } from '@inertiajs/inertia-vue3'
import CustomerSelector from '@/Shared/CustomerSelector';
import JetApplicationMark from '@/Jetstream/ApplicationMark.vue'
import JetDropdownLink from '@/Jetstream/DropdownLink'
import JetDropdown from '@/Jetstream/Dropdown'
import JetNavLink from '@/Jetstream/NavLink';
import UseUserAuth from '@/Composables/UseUserAuth';

export default {
    setup () {
        const { isCustomer } = UseUserAuth(usePage().props.value.user);

        return { isCustomer };
    },

    components: {
        CustomerSelector,
        JetApplicationMark,
        JetDropdownLink,
        JetDropdown,
        JetNavLink,
    },

    props: ['categories'],

    data() {
        return {
            multipleCustomers: false,
        }
    },

    methods: {
        logout() {
            this.$inertia.post(route('logout'));
        },
    },

    mounted() {
        this.$watch(
            () => { return this.$refs.selector?.linkedCustomers; },
            (newVal) => {
                if(newVal.length > 1) this.multipleCustomers = true;
                else this.multipleCustomers = false;
            }
        )
    }

}
</script>

<style scoped>
    .categories {
        height: calc(100vh - 346px);
    }

    /* When customer selector is visible */
    .categories-with-customers {
        height: calc(100vh - 380px) !important;
    }

    .categories a,
    .categories-with-customers a {
        @apply leading-tight;
    }

    /* Scrollbar */
    .categories::-webkit-scrollbar-track {
        border-radius: 10px;
        box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
        -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.33);
        background-color: #F5F5F5;
    }

    .categories::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #F5F5F5;
    }

    .categories::-webkit-scrollbar-thumb {
        border-radius: 10px;
        box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
        -webkit-box-shadow: inset 0 0 3px rgba(0,0,0,0.3);
        background-color: #888;
    }
</style>
